"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Analytics = function Analytics(_ref) {
  var id = _ref.id,
      onlyPathname = _ref.onlyPathname,
      basename = _ref.basename,
      location = _ref.location;

  var lastPathname = _react.default.useRef(location.pathname);

  var sendPageView = function sendPageView() {
    // Do nothing if GA was not initialized due to a missing tracking ID.
    if (!window.ga) {
      return;
    } // Do nothing if trackPathnameOnly is enabled and the pathname didn't change.


    if (onlyPathname && location.pathname === lastPathname.current) {
      return;
    }

    lastPathname.current = location.pathname; // Sets the page value on the tracker. If a basename is provided, then it is prepended to the pathname.

    var page = basename ? "".concat(basename).concat(location.pathname) : location.pathname;
    window.ga('set', 'page', page);
    window.ga('send', 'pageview');
  };

  _react.default.useEffect(function () {
    if (!id) {
      console.error('[Google Analytics] Tracking ID is required.');
      return;
    } // Initialize Google Analytics


    window.ga('create', id, 'auto');
  }, []);

  _react.default.useEffect(function () {
    if (!window.ga) {
      return;
    }

    sendPageView();
  }, [location.pathname]);

  return _react.default.createElement("div", null);
};

var _default = (0, _reactRouterDom.withRouter)(Analytics);

exports.default = _default;